import {
  CeckpointStepV2,
  CheckpointRequest,
  CheckpointResponse,
  CheckpointV2,
  StageRequest,
  StageResponse,
} from "../types/checkpoint";
import api from "./index";

export const createCheckpoint = async (payload: CheckpointRequest) => {
  const response = await api.post(`/v1/checkpoints/`, payload);
  return response.data;
};

export const createNewCheckpoint = async (payload: Partial<CheckpointV2>) => {
  const response = await api.post(`/v2/checkpoints/`, payload);
  return response.data;
};

export const uploadStepDocument = async (checkpointId: string, stepId: string, fieldId: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post(
    `/v2/checkpoints/${checkpointId}/steps/${stepId}/documents/${fieldId}`,
    formData,
  );
  return response.data;
};

export const getAllCheckpoints = async (): Promise<CheckpointResponse[]> => {
  const response = await api.get(`/v1/checkpoints/`);
  return response.data.data.result;
};

export const getAllCheckpointsV2 = async (type?: string, page?: number, size?: number, title?: string) => {
  const params = new URLSearchParams();

  const queryParams: Record<string, string | undefined> = {
    type,
    page: page?.toString(),
    size: size?.toString(),
    title,
  };

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined) {
      params.append(key, value);
    }
  });

  const response = await api.get(`/v2/checkpoints/?${params}`);
  return response.data;
};

export const updateFavoriteCheckpointV2 = async (id: string, payload: { isFavorite: boolean }) => {
  const response = await api.patch(`v2/checkpoints/${id}/favorite`, payload);
  return response.data;
};

export const updateCheckpoint = async (id: string, payload: CheckpointV2) => {
  const response = await api.patch(`v1/checkpoints/${id}`, payload);
  return response.data;
};

export const updateCheckpointV2 = async (id: string, payload: Partial<CheckpointV2>) => {
  const response = await api.put(`/v2/checkpoints/${id}`, payload);
  return response.data;
};

export const deleteCheckpointV2 = async (id: string) => {
  const response = await api.delete(`v2/checkpoints/${id}`);
  return response.data;
};

export const getCheckpointDetailByIdV2 = async (id: string) => {
  const response = await api.get(`/v2/checkpoints/${id}`);
  return response.data;
};

export const getTemplateCheckpointV2 = async (id: string) => {
  const response = await api.get(`/v2/checkpoints/steps/template?type=${id}`);
  return response.data;
};

export const getTemplatesCheckpointV2 = async () => {
  const response = await api.get(`/v2/checkpoints/steps/templates`);
  return response.data;
};

export const getStepDocuments = async (checkpointId: string, stepId: string, fieldId: string) => {
  const response = await api.get(
    `/v2/checkpoints/${checkpointId}/steps/${stepId}/documents/${fieldId}`,
  );
  return response.data;
};

export const getStepDocumentFile = async (checkpointId: string, stepId: string, fieldId: string, fileName: string): Promise<string> => {
  const response = await api.get(
    `/v2/checkpoints/${checkpointId}/steps/${stepId}/documents/${fieldId}/${fileName}`,
    { responseType: "blob" },
  );
  return URL.createObjectURL(response.data);
};

export const deleteCheckpoint = async (id: string) => {
  const response = await api.delete(`v1/checkpoints/${id}`);
  return response.data;
};

export const addStageToCheckpoint = async (checkpointId: string, payload: StageRequest): Promise<StageResponse> => {
  const response = await api.post(`v1/checkpoints/${checkpointId}/stages`, payload);
  return response.data.data.result;
};

export const deleteStageFromCheckpoint = async (checkpointId: string, stageId: string) => {
  const response = await api.delete(`v1/checkpoints/${checkpointId}/stages/${stageId}`);
  return response.data;
};

export async function updateStage(checkpointId: string, stageId: string, payload: StageRequest) {
  const { data } = await api.patch(`v1/checkpoints/${checkpointId}/stages/${stageId}`, payload);
  return data.data.result;
}

export async function getStageById(stageId: string) {
  const { data } = await api.get(`v1/checkpoints/stages/${stageId}`);
  return data.data.result;
}
